module.exports = __webpack_public_path__ + "img/MihmedTahir.cb46a5ae.jpg";